import './bootstrap';
import '../css/app.css';
// Import Ziggy routes file
import {Ziggy} from './ziggy';

// Make Ziggy globally available
window.Ziggy = Ziggy;

import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy/dist/index.esm.js';
// import { startMemoryMonitor } from './memory-monitor';
import {usePage} from '@inertiajs/vue3';

// Import global components
import BaseLayout from '@/Layouts/BaseLayout.vue';
import TopMenu from '@/Components/Navigation/TopMenu.vue';
import SubcategoryCard from '@/Components/Categories/SubcategoryCard.vue';
// import CategoryMetaTags from '@/Components/MetaTags/CategoryMetaTags.vue';
import HeaderIcons from '@/Components/Icons/HeaderIcons.vue';
import LanguageSwitcher from '@/Components/Navigation/LanguageSwitcher.vue';

// Import pages that might need explicit registration
import MetaTagsExample from '@/Pages/Example/MetaTagsExample.vue';

//import PrimeVue from 'primevue/config';
// Import a theme (optional, but recommended)
// import Aura from '@primeuix/themes/aura';
// Import PrimeVue components and directives
// import AutoComplete from 'primevue/autocomplete';
// import Tooltip from 'primevue/tooltip';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => title ? title : appName,
    resolve: (name) => {
        // First try to resolve from explicit imports
        if (name === 'Example/MetaTagsExample') {
            return MetaTagsExample;
        }
        // Then fall back to the default resolver
        return resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'));
    },
    setup({el, App, props, plugin}) {
        // Create the Vue application
        const app = createApp({
            render: () => h(App, props),
            mounted() {
                // console.log('Inertia app mounted, props:', props);
            }
        });

        // Register global components
        app.component('BaseLayout', BaseLayout);
        app.component('TopMenu', TopMenu);
        app.component('SubcategoryCard', SubcategoryCard);
        // app.component('CategoryMetaTags', CategoryMetaTags);
        app.component('HeaderIcons', HeaderIcons);
        app.component('LanguageSwitcher', LanguageSwitcher);
        // Register AutoComplete component globally
        // app.component('AutoComplete', AutoComplete);
        // Register Tooltip directive globally
        // app.directive('tooltip', Tooltip);

        // Add global translation function
        app.config.globalProperties.$t = (key) => {
            // Handle undefined or null keys
            if (!key) return '';

            const translations = usePage().props.translations || {};

            // First try direct access with the full key (for flat keys like "pages.contact_success.heading")
            if (translations[key] !== undefined) {
                return translations[key];
            }

            // If not found as a flat key, try nested object traversal (for backward compatibility)
            if (typeof key === 'string' && key.includes('.')) {
                const keys = key.split('.');
                let value = translations;

                for (const k of keys) {
                    if (value && typeof value === 'object' && k in value) {
                        value = value[k];
                    } else {
                        return key; // Key not found, return the original key
                    }
                }

                return value;
            }

            return translations[key] || key;
        };

        // Use the plugins
        app.use(plugin);
        app.use(ZiggyVue, Ziggy);

        // Register PrimeVue with a theme
        // app.use(PrimeVue, {
        //     theme: {
        //         preset: Aura
        //     }
        // });

        // Mount the app
        app.mount(el);

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});

// Cleanup Blade fallback meta tags once Inertia has rendered the head
// This prevents duplicate meta tags when SSR is off/broken but JS runs
if (typeof window !== 'undefined') {
  document.addEventListener('inertia:finish', () => {
    try {
      document.querySelectorAll('meta[data-fallback="true"]').forEach((el) => el.remove());
    } catch (e) {
      // no-op
    }
  });

  (function(){
    const title = document.title;
    const loc = window.location.href;
    const path = window.location.pathname + window.location.search;
    if (typeof window.gtag === 'function') {
      if (window.__ga_last_path !== path) {
        window.gtag('event', 'page_view', {
          page_title: title,
          page_location: loc,
          page_path: path
        });
        window.__ga_last_path = path;
      }
    }
  })();

  // Update CSRF token after each Inertia navigation to prevent 419 errors
  document.addEventListener('inertia:success', (event) => {
    const csrfToken = event.detail.page.props.csrf_token;
    if (csrfToken) {
      // Update meta tag
      const metaTag = document.querySelector('meta[name="csrf-token"]');
      if (metaTag) {
        metaTag.setAttribute('content', csrfToken);
      }
      // Update axios default header
      if (window.axios) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      }
    }

    const title = document.title;
    const loc = window.location.href;
    const path = window.location.pathname + window.location.search;
    if (typeof window.gtag === 'function') {
      if (window.__ga_last_path !== path) {
        window.gtag('event', 'page_view', {
          page_title: title,
          page_location: loc,
          page_path: path
        });
        window.__ga_last_path = path;
      }
    }
  });
}
